import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockSuccessWithDollarColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 53 50" {...props}>
      <g clipPath="url(#clip0_clock_success_dollar)">
        <circle
          cx={27.957}
          cy={24.9804}
          r={24.9804}
          stroke="url(#paint0_clock_success_dollar)"
          strokeWidth={9.992_16}
        />
        <path
          stroke="#094534"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M27.957 21.064V25.4511L31.957 29.064"
        />
        <path
          stroke="#094534"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18.707 18.064V22.064H22.707"
        />
        <path
          stroke="#094534"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.207 28.7306C20.4787 32.4204 23.9101 35.064 27.9435 35.064C33.0596 35.064 37.207 30.8107 37.207 25.564C37.207 20.3173 33.0596 16.064 27.9435 16.064C24.1051 16.064 20.812 18.458 19.4065 21.8695"
        />
      </g>
      <rect
        x={0.196_721}
        y={0.507_756}
        width={15.3442}
        height={15.3442}
        rx={7.672_11}
        fill="#0D2B57"
      />
      <rect
        x={0.196_721}
        y={0.507_756}
        width={15.3442}
        height={15.3442}
        rx={7.672_11}
        stroke="#fff"
        strokeWidth={0.393_441}
      />
      <path
        stroke="#fff"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.97656 4.81818V4M7.97656 12.1818V13M9.709 6.04545C9.36319 5.55634 8.71684 5.22727 7.97656 5.22727H7.75434C6.7725 5.22727 5.97656 5.87849 5.97656 6.68182V6.74427C5.97656 7.31886 6.37334 7.84414 7.00148 8.1011L8.95164 8.8989C9.57978 9.15586 9.97656 9.68114 9.97656 10.2557C9.97656 11.0935 9.14645 11.7727 8.12246 11.7727H7.97656C7.23628 11.7727 6.58994 11.4437 6.24413 10.9545"
      />
      <defs>
        <linearGradient
          id="paint0_clock_success_dollar"
          x1={27.957}
          y1={0}
          x2={27.7421}
          y2={37.737}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195_043} stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <clipPath id="clip0_clock_success_dollar">
          <rect x={2.976_56} width={49.9608} height={49.9608} rx={24.9804} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClockSuccessWithDollarColored);
export default ForwardRef;
